import { Component, Input, HostListener, ViewEncapsulation, ElementRef } from '@angular/core';
import { ControlValueAccessor, FormControl } from '@angular/forms';
import { HttpService } from '../http.service';

@Component({
	// tslint:disable-next-line: component-selector
	selector: 'tr2-file-upload',
	templateUrl: './file-upload.component.html',
	styleUrls: ['./file-upload.component.scss'],
	encapsulation: ViewEncapsulation.None
})

export class FileUpload implements ControlValueAccessor {
	@Input() progress;
	@Input() formData;
	@Input() sistema: string;
	onChange: Function;
	file: File | null = null;

	@HostListener('change', ['$event.target.files']) emitFiles( event: FileList ) {
		const file = event && event.item(0);
		this.onChange(file);
		this.file = file;
	}

	constructor(
		private host: ElementRef<HTMLInputElement>,
		private httpService: HttpService
		) {
	}

	writeValue( value: null ) {
		// clear file input
		this.host.nativeElement.value = '';
		this.file = null;
	}

	registerOnChange( fn: Function ) {
		this.onChange = fn;
	}

	registerOnTouched( fn: Function ) {
	}

	// submit() {
	// 	this.httpService.uploadfile(this.sistema, this.toFormData(this.formData), {
	// 	  reportProgress: true,
	// 	  observe: 'events'
	// 	}).pipe(
	// 	  this.uploadProgress(progress => (this.percentDone = progress)),
	// 	  this.toResponseBody()
	// 	).subscribe(response => {
	// 	  this.progress = 0;
	// 	  this.signup.reset();
	// 	  // do something with the response
	// 	});
	//   }

	//   uploadProgress<T>( cb: ( progress: number ) => void ) {
	// 	return tap(( event: HttpEvent<T> ) => {
	// 	  if ( event.type === HttpEventType.UploadProgress ) {
	// 		cb(Math.round((100 * event.loaded) / event.total));
	// 	  }
	// 	});
	//   }
	//   toResponseBody<T>() {
	// 	return pipe(
	// 	  filter(( event: HttpEvent<T> ) => event.type === HttpEventType.Response),
	// 	  map(( res: HttpResponse<T> ) => res.body)
	// 	);
	//   }
	// toFormData<T>( formValue: T ) {
	// 	const formData = new FormData();
	// 	for ( const key of Object.keys(formValue) ) {
	// 		const value = formValue[key];
	// 		formData.append(key, value);
	// 	}
	// 	return formData;
	// }
	// requiredFileType( type: string ) {
	// 	return function (control: FormControl) {
	// 		const file = control.value;
	// 		if ( file ) {
	// 			const extension = file.name.split('.')[1].toLowerCase();
	// 			if ( type.toLowerCase() !== extension.toLowerCase() ) {
	// 				return {
	// 					requiredFileType: true
	// 				};
	// 			}
	// 			return null;
	// 		}
	// 		return null;
	// 	};
	// }

}
